<template>
    <li class="media mb-4">
        <Avatar :size="50" :email="review.user.email" class="mr-3" />
        <div class="media-body">
            <h4 class="my-0"><BetterLink :to="{ name: 'User Profile', params: { slug: review.user.slug } }">{{ review.user.name }}</BetterLink></h4>
            <p class="mb-1" style="margin-top:-5px;"><small><strong>{{ formattedReviewDate }}</strong></small></p>
            <div v-html="$autoP(review.review)"></div>
            <RatingChart v-if="hasRatings" :ratings="review.my_ratings" />
        </div>
    </li>
</template>

<script>
import Avatar from '@/components/elements/Avatar'
import RatingChart from "@/components/elements/RatingChart"

export default {
    name: 'SiteReview',
    components: {
        Avatar,
        RatingChart,
    },
    props: {
        review: {
            type: Object,
            required: true,
        }
    },
    computed: {
        formattedReviewDate() {
            let components = this.review.visit_date.split('-')
            let monthNames = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
            let dateString = monthNames[parseInt(components[1])]
            if (components[2] > 0) {
                dateString += ` ${components[2]},`
            }
            dateString += ` ${components[0]}`
            return dateString
        },
        hasRatings() {
            return Object.keys(this.review.my_ratings).some(key => {
                return this.review.my_ratings[key] != null
            })
        },
    },
};
</script>

<style lang="scss" scoped></style>